import {useEffect, useState} from 'react';

import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';

import {StatementInvoiceService} from '../StatementInvoiceService';
import {ToastService} from '../../../AppToast';

import {useForm} from '../../../shared/hooks/Form';
import {useTranslation} from '../../../shared/language';

export const DialogAttachment = ({display, setDisplay, selectedItem}) => {
  const {t} = useTranslation();

  const [submitting, setSubmitting] = useState(false);

  const [id, setId] = useState(null);
  const [fileUpload, setFileUpload] = useState(null);
  const [isUploadFile, setIsUploadFile] = useState(null);

  useEffect(() => {
    if (display && selectedItem) {
      StatementInvoiceService.getByInvoice(selectedItem.invoiceId).then(({isUplooadFile, fileUpload, id}) => {
        setIsUploadFile(isUplooadFile);
        setFileUpload(fileUpload);
        setId(id);
      });
    }
  }, [display, selectedItem]);

  const {render: renderFormUpload, valid: formUploadValid, getValue: getUploadValue} = useForm({
    fields: [
      {field: 'files', header: t('common.uploadPdf'), required: true, type: 'file', InputFileProps: {accept: '.pdf'}, className: 'md:col-12 mb-1'}
    ]
  });

  const print = () => {
    window.open(StatementInvoiceService.getPdfUpload(id), '_blank');
  }

  const upload = () => {
    if (!submitting && formUploadValid() && selectedItem && selectedItem.invoiceId) {
      setSubmitting(true);

      const {files} = getUploadValue();

      const formData = new FormData();
      formData.append('files', files);

      StatementInvoiceService.upload(selectedItem.invoiceId, formData).then(() => {
        setDisplay(false);
        ToastService.success();
      }).finally(() => {
        setSubmitting(false);
      });
    }
  }

  return (
    <Dialog header={t('common.attachStatement')} visible={display} style={{width: '500px'}} position="top" onHide={() => setDisplay(false)}>
      {renderFormUpload()}

      {fileUpload &&
				<div className="mt-2">
					<a href={StatementInvoiceService.getPdfUpload(id)} target="_blank" rel="noreferrer">{fileUpload}</a>
				</div>
      }

      <div className="flex justify-content-end mt-2">
        {isUploadFile &&
					<Button label={t('common.print')} icon="pi pi-print" className="p-button-outlined p-button-sm mr-2" onClick={print}/>
        }
        <Button label={t('common.save')} icon="pi pi-check" className="p-button-sm mr-2" onClick={upload} loading={submitting}/>
        <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-outlined p-button-secondary p-button-sm"/>
      </div>
    </Dialog>
  );
}
